export const ImageFormats = ['image/jpeg', 'image/gif', 'image/png'];
export const MaxPhotoSizeInMb = 20;
export const MaxImageSizeInBytes = MaxPhotoSizeInMb * 1000000;
